import { createStore, combineReducers } from "redux";

import countReducer from "./modules/counter/reducers";

const reducers = combineReducers({ count: countReducer });

const store = createStore(reducers);

export default store;
